import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { CustomizerFilter, FilterOption } from '../models';
import { predictFilterOptionsState } from './predict-filter-options-state';

export const processFilters = (groups: IProductWithAttributes[] = [], filters: CustomizerFilter[] = []) => {
  const forecastedFilters: CustomizerFilter[] = predictFilterOptionsState(groups, filters);

  filters.forEach((f: CustomizerFilter, i: number) => {
    f.options.forEach((o: FilterOption, j: number) => {
      o.disabled = forecastedFilters[i].options[j].disabled;
    });
  });
};
